export class ExtendEwayBill {
    public eway_bill_number!: string;
    public eway_bill_valid_date!: string;
    public place_of_consignor!: string;
    public legal_name_of_consignee!: string;
    public state_of_consignor!: string;
    public VHNO!: string;
    public Current_Place!: string;
    public from_pincode!: string;
    public to_pincode!: string;
    public Remaining_distance!: number;
    public TMode!: string;
    public EV_Resion!: string;
    public Extend_remarks!: string;
    public consignment_status!: string;
    public transit_type!: string;
    public transporter_document_number!: string;
    public transporter_document_date!: string;
    public AddressLine1!: string;
    public AddressLine2!: string;
    public AddressLine3!: string;
}